import { createFileRoute, redirect } from '@tanstack/react-router';

const AGENT_SYSTEM_ADMIN = '/agent-system-admin/';

export const Route = createFileRoute('/admin/itops-agent/$agentId')({
  beforeLoad: () => {
    throw redirect({ href: AGENT_SYSTEM_ADMIN });
  },
});
